import React from 'react'
import { styled } from 'styled-components'
import {
	isPaused,
	isDeathHappening,
	useMissionStateSelector,
} from '../../../context'

export default function PauseScreen(): React$Node {
	const missionIsPaused = useMissionStateSelector(isPaused)
	const classIsDying = useMissionStateSelector(isDeathHappening)
	return missionIsPaused && !classIsDying ? (
		<PauseWrapper className="font-game-headline">
			<PauseTitle>Paused</PauseTitle>
			<PauseInfo>Eyes on your teacher</PauseInfo>
		</PauseWrapper>
	) : null
}

const PauseWrapper = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;

	background-color: rgba(0, 0, 0, 0.5);
	color: white;
	letter-spacing: 2px;
	${({ theme }) => `
    	font-weight: ${theme.fontBold};
		z-index:${theme.zAlwaysShow};
    `}
`

const PauseTitle = styled.div`
	${({ theme }) => `
        font-size: ${theme.fonthero};
        margin-bottom: ${theme.spacing2x};
    `}
`
const PauseInfo = styled.div`
	font-size: 40px;
`
